import { ReactNode } from "react";
import { AngularBridge } from "../../other/bridgeSetup/AngularBridge";
import styled from "@emotion/styled";

export const FrontOfficePageWrapper = (props: {
    view: "review" | "summary";
    children: ReactNode;
}) => {
    return (
        <Container>
            <Title>Broker interactions {props.view}</Title>
            <AngularBridge
                name="c-interaction-review-header"
                props={{
                    componentKey: "interactionReview",
                    onlyShowActionBar: true,
                    isReactApp: true,
                    forceView: props.view
                }}
            />
            <Page>{props.children}</Page>
        </Container>
    );
};

const Container = styled("div")({
    position: "absolute",
    left: 40,
    right: 40,
    top: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column"
});

const Title = styled("div")(props => ({
    fontSize: props.theme.fontSizes.veryLarge,
    fontWeight: "bold",
    marginTop: 30,
    marginBottom: 30
}));

const Page = styled("div")({
    flexGrow: 1,
    position: "relative"
});
